import {useState,useEffect,useRef} from 'react';
import {rolepermissionServices} from '../../services/rolepermissionServices';
import { Toast } from 'primereact/toast';

const Createpermission = () =>{
   const [initialvalues,setValues] = useState({
      name:'',
       status:'inactive'
   });

  const [permissions,setPermissions] = useState([]);
  const toast = useRef(null);

   useEffect(()=>{
      getpermissions();  
   },[])

   const handleChanges = (event) =>{
       setValues((prevdata)=>{
            return {
                ...prevdata,
                [event.target.name]: event.target.value    
            }
       }) 
   }

   const createpermission = (e) =>{
      e.preventDefault();
      console.log("initial values"); 
      console.log(initialvalues);
      rolepermissionServices.createpermission(initialvalues).then((response)=>{
          if(response.status == 200){
               //console.log("permission created");
               toast.current.show({ severity: 'success', summary: 'Permission', detail: 'Updated Successfully' });
               getpermissions();  
          }else{
               toast.current.show({ severity: 'error', summary: 'Permission', detail: response.data.data });
               // getpermissions(); 
          }
      }).catch((error)=>{
         toast.current.show({ severity: 'error', summary: 'Permission', detail: 'Error' });
      })
   } 
   
   const getpermissions = () =>{
      rolepermissionServices.getpermissions().then((response)=>{
            if(response.status == 200){
               setPermissions(response.data.data);    
            }else{
               setPermissions([]);     
            }
      }).catch((error)=>{
         setPermissions([]); 
      })  
   }


   const displayPermissions = () =>{
      let array = [];
      permissions.forEach((value,index)=>{
         array.push(<tr>
             <td>{index + 1}</td>
             <td>{value.name}</td>
             <td>{value.status}</td>
             <td>
                 <button className='btn btn-warning btn-sm '><i className='fa fa-edit'></i></button>
                 &nbsp;
                 <button className='btn btn-danger btn-sm'><i className='fa fa-trash'></i></button>
             </td>
         </tr>); 
      });  
      return array;
   }



   return (
      <>
          <Toast ref={toast}/>
          <div className="card">
           <form onSubmit={(e)=>createpermission(e)}>
            <div class="row">
                <div className="col-md-3"> 
                 <div class="form-group">
                    <label for="name">Permisson Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        placeholder="Permission name"
                        required
                        onChange={handleChanges}
                    />
                   </div>
                </div>

                <div className="col-md-2"> 
                 <div class="form-group">
                    <label for="name">Status</label>
                    <select name='status' value={initialvalues.status} className='form-control' required onChange={handleChanges}>
                        <option value="inactive">Inactive</option>
                        <option value="active">Active</option>
                     </select>  
                  </div>
                </div>
                
                <div className="col-md-3">
                   <div style={{marginTop:'26px'}}></div> 
                   <div class="form-group">
                      <button className="btn btn-success btn-round" type="submit">Save</button>
                   </div>
                </div>
                
                 </div>
               </form>
               <br></br>
               
               <hr class="mt-2 mb-3"/>
               <div className='row'>
                   <div className='col-md-12'>
                   <table id="basic-datatables" class="display table table-striped table-hover">
                           <thead>
                           <tr>
                               <th>SR NO</th>
                               <th>Name</th>
                               <th>Status</th>
                               <th>Action</th>
                           </tr>
                           </thead>
                           <tbody>
                                {displayPermissions()}
                           </tbody>   
                      </table>
                   </div>  
               </div>
             </div>   
      </>
   );   
}

export default Createpermission;